<template>
<div :class="{ swipeable: this.swipeable }">
  <div class="featured-card" v-for="plate in featuredPlatelist" :key="plate.id" @click="toPlanDetail(plate)">
    <div class="featured-card-hero" :style="`backgroundImage: url(${plate.featuredimageurl})`">
      <div
        class="img-wrapper"
        v-if="plate.influencerData && plate.influencerData.profileimage"
        :style="`backgroundImage: url(${plate.influencerData.profileimage})`"
      ></div>
      <div class="hero-content">
        {{ plate.description }}
      </div>
    </div>
    <div class="featured-card-footer">
      <div class="footer-content">
        {{ plate.title }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import { kitchenDrawerMethods, platelistMethods } from '@state/helpers';

export default {
  components: {},
  props: {
    cardType: {
      type: String,
      required: false,
    },
    isEmbed: {
      type: Boolean,
      required: false,
    },
    platelist: {
      type: Array,
      required: false,
    },
    swipeable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    featuredPlatelist() {
      return this.platelist.filter((item) => item.isfeatured === true);
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...platelistMethods,
    async toPlanDetail(plate) {
      await this.getPlatelistDays(plate.id);
      this.navigateDeeper({
        title: this.$t('lblPlanDetails'),
        component: 'PlanDetail',
        data: plate,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.swipeable {
  display: flex;
  overflow-x: auto;
  scroll-snap-points-y: repeat(300px);
  scroll-snap-type: mandatory;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
}

.featured-card {
  margin-right: 1.4rem;
  max-height: 26.9rem;
  min-width: 90%;
  scroll-snap-align: start;

  &:last-child {
    padding-right: 2rem;
  }

  &:hover {
    cursor: pointer;
  }

  .featured-card-hero {
    background-size: cover;
    border: 1px solid $base-border-color;
    border-radius: 0.7rem;
    box-shadow: $color-card-shadow;
    color: $color-card-featured-hero-text;
    height: 13.6rem;
    padding: 1rem;
    position: relative;

    &::before {
      background-color: $color-card-featured-hero-overlay;
      border-radius: $base-border-radius;
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    .img-wrapper {
      align-items: center;
      background-position: center;
      background-size: cover;
      border-radius: 0.4rem;
      box-shadow: $color-card-image-shadow;
      display: flex;
      height: 6rem;
      justify-content: center;
      padding-top: 0.5rem;
      position: absolute;
      right: 1.3rem;
      top: 1rem;
      width: 6rem;

      img {
        width: 100%;
      }
    }

    .hero-content {
      bottom: 1.5rem;
      font-size: 1rem;
      height: 3.6rem;
      overflow: hidden;
      position: absolute;
      width: 75%;
    }
  }

  .featured-card-footer {
    align-items: center;
    display: flex;
    font-size: 0.9rem;
    justify-content: space-between;
    padding: 1.1rem 0;

    .footer-content {
      flex: 0.75;
      font-size: 1.7rem;
      line-height: 1.2;
      text-transform: capitalize;
    }
  }
}
</style>
